import { useQuery } from '@apollo/client';
import { Navigate, useParams } from 'react-router-dom';
import {
  MediaItemVersionsDocument,
  MediaItemVersions as Versions,
} from '~/components/MediaItemVersions';
import { LoadingPane } from '~/components/loading-pane';
import { useAppContext } from '~/contexts';

export const MediaItemVersions = () => {
  const params = useParams<{ mediaItemId: string }>();
  const mediaItemId = parseInt(params.mediaItemId ?? '');
  const { currentNetwork } = useAppContext();

  const { data, loading, error } = useQuery(MediaItemVersionsDocument, {
    fetchPolicy: 'cache-first',
    variables: { id: mediaItemId, networkId: currentNetwork.id },
  });

  if ((!loading && !data) || error) return <Navigate to="/not-found" />;

  const mediaItem = data?.network?.mediaItem;

  return (
    <LoadingPane in={loading && !data}>
      {mediaItem && <Versions mediaItem={mediaItem} />}
    </LoadingPane>
  );
};
